<template>
  <VContainer fluid v-if="!loading">
    <!-- DESKTOP -->
    <VContainer class="d-none d-lg-block">
      <VRow class="px-16">
        <VCol cols="12" class="px-16">
          <VCard class="elevation-10 px-16">
            <VCardTitle>
              <VBtn
                color="primary"
                rounded="xl"
                @click="$router.push('/' + $i18n.locale + '/blog')"
              >
                <VIcon class="mr-2" icon="mdi-arrow-left" />
                {{ $t('buttons.go_back') }}
              </VBtn>
            </VCardTitle>

            <VCardTitle class="text-h2 text-secondary" style="word-break: keep-all;">
              {{ article.title }}
            </VCardTitle>

            <VCardSubtitle class="text-h4 text-accent text-justify">
              {{ article.subtitle }}
            </VCardSubtitle>

            <VCardSubtitle class="text-caption mt-n8">
              <VRow class="mt-2 ml-2">
                <VCol cols="auto" class="ma-0 pa-0">
                  <VAvatar size="40">
                    <VImg :src="authorPhoto" :alt="article.autor" contain />
                  </VAvatar>
                </VCol>

                <VCol cols="auto" class="ma-0 pa-0">
                  <div class="ml-2">
                    <span class="text-accent">({{ article.autor }} - {{ article.data }})</span>
                    <br />
                    <gb-social-button
                      v-if="article.autor_id != null"
                      @click="openSocialNetwork('linkedin', $getSocialNetwork(article.autor_id, 'Linkedin'))"
                      network="linkedin"
                      size="mini"
                      :reverse="true"
                      theme="light"
                      style="border: none;"
                      class="gb-social-button__focuser ml-n2"
                    />
                  </div>
                </VCol>
              </VRow>
            </VCardSubtitle>

            <VCardText class="text-center">
              <VImg
                contain
                max-width="500"
                style="margin: auto;"
                :src="articleHero"
                :alt="article.title"
              />
            </VCardText>

            <VCardText class="text-justify text-body-1" v-html="article.body" />
          </VCard>
        </VCol>
      </VRow>
    </VContainer>

    <!-- MOBILE -->
    <VContainer class="d-md-none">
      <VRow>
        <VCol cols="12">
          <VCard class="elevation-10">
            <VCardTitle>
              <VBtn
                color="primary"
                rounded="xl"
                @click="$router.push('/' + $i18n.locale + '/blog')"
              >
                <VIcon class="mr-2" icon="mdi-arrow-left" />
                {{ $t('buttons.go_back') }}
              </VBtn>
            </VCardTitle>

            <VCardTitle class="text-h4 text-secondary" style="word-break: keep-all;">
              {{ article.title }}
            </VCardTitle>

            <VCardSubtitle class="text-h6 text-accent">
              {{ article.subtitle }}
            </VCardSubtitle>

            <VCardSubtitle class="text-caption mt-n8">
              <VRow class="mt-2 ml-2">
                <VCol cols="auto" class="ma-0 pa-0">
                  <VAvatar size="36">
                    <VImg :src="authorPhoto" :alt="article.autor" contain />
                  </VAvatar>
                </VCol>

                <VCol cols="auto" class="ma-0 pa-0">
                  <div class="ml-2">
                    <span class="text-accent">({{ article.autor }} - {{ article.data }})</span>
                    <br />
                    <gb-social-button
                      v-if="article.autor_id != null"
                      @click="openSocialNetwork('linkedin', $getSocialNetwork(article.autor_id, 'Linkedin'))"
                      network="linkedin"
                      size="mini"
                      :reverse="true"
                      theme="light"
                      style="border: none;"
                      class="gb-social-button__focuser ml-n2"
                    />
                  </div>
                </VCol>
              </VRow>
            </VCardSubtitle>

            <VCardText class="text-center">
              <VImg
                contain
                max-width="500"
                style="margin: auto;"
                :src="articleHero"
                :alt="article.title"
              />
            </VCardText>

            <VCardText
              class="text-justify text-body-1 mb-12"
              v-html="article.body"
            />
          </VCard>
        </VCol>
      </VRow>
    </VContainer>
  </VContainer>
</template>

<script>
import ARTICLES from '@/json_articles/articles.json'

export default {
  name: 'BlogArticle',
  data () {
    return {
      loading: true,
      article: {
        id: '',
        title: '',
        subtitle: '',
        body: '',
        foto: '',
        autor: '',
        autor_photo: '',
        autor_id: null,
        data: ''
      }
    }
  },
  computed: {
    // As imagens vêm da pasta /public/json_articles
    authorPhoto () {
      if (!this.article?.autor_photo) return ''
      return `/json_articles/autores/${this.article.autor_photo}`
    },
    articleHero () {
      if (!this.article?.id || !this.article?.foto) return ''
      return `/json_articles/images/${this.article.id}/${this.article.foto}`
    }
  },
  mounted () {
    const id = this.$route.params.id
    const found = ARTICLES.articles.find(a => String(a.id) === String(id))
    if (found) this.article = found
    this.loading = false
  },
  methods: {
    openSocialNetwork (social, link) {
      if (social === 'linkedin' && link) {
        window.open(link, '_blank')
      }
    }
  }
}
</script>

<style>
.gb-social-button__focuser{
  border: none !important;
}
</style>
